<template>
    <div class="main-container w-full min-h-[90vh] bottom-8">
        <div class="fixed top-0 w-full z-50">
            <div class="z-50 relative">
                <NavBar :title="title" @minimize="minimize" @close="close"/>
            </div> 
            <div class="z-40 relative">
                <NavBarCRM @openPage="selectTab"/>
            </div>
            <div class="z-30">
                <PagesTab @openPage="selectedTab" @closePage="closeTab"/>
            </div>
        </div>

        <div class="tab-content z-20 overflow-y-hidden">
            <keep-alive :include="cachedComponents">
                <component 
                    :is="activeComponent"
                 />
            </keep-alive>
        </div>
        
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';
import NavBar from '@/components/NavBar.vue'
import NavBarCRM from '@/components/CRM/NavBarCRM.vue';
import PagesTab from '@/components/CRM/PagesTab.vue';
import Dashboard from '@/components/CRM/Dashboard.vue';
import Sales_Reps from '@/components/CRM/Sales_Reps.vue';
import Lead_Sources from '@/components/CRM/Lead_Sources.vue';
import Marketing_Channels from '@/components/CRM/Marketing_Channels';
import Marketing_Campaigns from '@/components/CRM/Marketing_Campaigns.vue';
import Leads from '@/components/CRM/Leads.vue';
import Import_Leads from '@/components/CRM/Import_Leads.vue';
import Email_Templates from '@/components/CRM/Email_Templates.vue';
import SMS_Templates from '@/components/CRM/SMS_Templates.vue';
import Design_Email_Template from '@/components/CRM/Design_Email_Template.vue';
import Design_SMS_Template from '@/components/CRM/Design_SMS_Template.vue';
import Customer_Inquiries from '@/components/CRM/Customer_Inquiries.vue';
import Inquiry_Responses from '@/components/CRM/Inquiry_Responses.vue';
import Lead_Accounts from '@/components/CRM/Lead_Accounts.vue';
import Lead_Contacts from '@/components/CRM/Lead_Contacts.vue';
import General_Invoices from '@/components/CRM/General_Invoices.vue';
import Invoice_Details from '@/components/CRM/Invoice_Details.vue';
import Opportunities from '@/components/CRM/Opportunities.vue';
import Lead_Tasks from '@/components/CRM/Lead_Tasks.vue';

export default{
    components:{
        NavBar,
        NavBarCRM,
        PagesTab,
        Dashboard,Sales_Reps,Lead_Sources,Marketing_Channels,Marketing_Campaigns,Leads,Email_Templates,
        SMS_Templates,Design_Email_Template,Design_SMS_Template,Import_Leads,Customer_Inquiries,Inquiry_Responses,
        Lead_Accounts,Lead_Contacts,General_Invoices,Invoice_Details,Opportunities,Lead_Tasks
    },
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    setup(){
        const store = useStore();
        const title = ref('CRM');
        const cachedComponents = computed(() =>  Array.from(store.state.pageTab.crmArray));
        const tabs = computed({
            get: ()=> store.state.pageTab.crmArray,
        });

        const activeTab = computed(() => store.state.pageTab.crmActiveTab);
    
        const activeComponent = computed(() => activeTab.value);
    
        const selectTab = (pageName) => {
            for(const [key, value] of Object.entries(pageName)){
                store.state.pageTab.crmActiveTab = value;
            }
        };
        const selectedTab = (pageName) => {
            store.state.pageTab.crmActiveTab = pageName;
        };
        const closeTab = (pageName) =>{
            let page = {"CRM":pageName};
            store.commit('pageTab/REMOVE_PAGE', page)
            store.commit(`${pageName}/RESET_SEARCH_FILTERS`)
            activeTab.value = store.state.pageTab.crmActiveTab;
            store.commit(`${pageName}/initializeStore`);
        }
        const minimize = () =>{
            store.commit('modulesTab/MINIMIZE_TAB')
        }
        const close = () =>{
            let myArray = Array.from(tabs.value);
            for(let i=0; i<myArray.length; i++){
                store.commit(`${myArray[i]}/RESET_SEARCH_FILTERS`)
                store.commit(`${myArray[i]}/initializeStore`)
            }
            store.commit('modulesTab/REMOVE_TAB', {'CRM':'CRM'}),
            store.commit('pageTab/CLEAR_PAGE_TAB', 'CRM');
            activeTab.value = store.state.pageTab.crmActiveTab;
        }
        return{
            close,minimize,title,activeComponent,selectTab, selectedTab, closeTab,activeTab, cachedComponents
        }
    },
    mounted(){
        const store = useStore();
        this.activeTab = store.state.pageTab.crmActiveTab;
    }
}
</script>

<style>
.tab-content{
    margin-top: 35px;
}
.main-container{
    max-height: 100vh;
    overflow: hidden;
}

</style>